import type { CategoryId } from '../types';

export interface CategoryMeta {
  id: CategoryId;
  icon: string;
  nameAr: string;
  nameEn: string;
}

/** Order here is the order shown on the "Practice by Topic" screen. */
export const CATEGORIES: CategoryMeta[] = [
  { id: 'road-signs', icon: '🛑', nameAr: 'إشارات الطريق', nameEn: 'Road Signs' },
  { id: 'traffic-signals', icon: '🚦', nameAr: 'الإشارات الضوئية', nameEn: 'Traffic Signals' },
  { id: 'right-of-way', icon: '↔️', nameAr: 'أحقية المرور', nameEn: 'Right of Way' },
  { id: 'speed-limits', icon: '⏱️', nameAr: 'حدود السرعة', nameEn: 'Speed Limits' },
  { id: 'parking', icon: '🅿️', nameAr: 'الوقوف', nameEn: 'Parking' },
  { id: 'school-buses', icon: '🏫', nameAr: 'حافلات المدرسة', nameEn: 'School Buses' },
  { id: 'emergency-vehicles', icon: '🚑', nameAr: 'مركبات الطوارئ', nameEn: 'Emergency Vehicles' },
  { id: 'alcohol-dui', icon: '🚫', nameAr: 'الكحول والقيادة', nameEn: 'Alcohol / DUI' },
  { id: 'highway-driving', icon: '🛣️', nameAr: 'القيادة على الطرق السريعة', nameEn: 'Highway Driving' },
  { id: 'lane-rules', icon: '🛤️', nameAr: 'قواعد المسارات', nameEn: 'Lane Rules' },
  { id: 'turning', icon: '↩️', nameAr: 'الانعطاف', nameEn: 'Turning' },
  { id: 'passing', icon: '🔀', nameAr: 'التجاوز', nameEn: 'Passing' },
  { id: 'pedestrians', icon: '🚶', nameAr: 'المشاة', nameEn: 'Pedestrians' },
  { id: 'railroad-crossings', icon: '🚂', nameAr: 'معابر السكك الحديدية', nameEn: 'Railroad Crossings' },
  { id: 'ohio-laws', icon: '📋', nameAr: 'قوانين أوهايو', nameEn: 'Ohio-Specific Laws' },
];

export const CATEGORY_BY_ID: Record<CategoryId, CategoryMeta> = CATEGORIES.reduce(
  (acc, c) => {
    acc[c.id] = c;
    return acc;
  },
  {} as Record<CategoryId, CategoryMeta>,
);

export const CATEGORY_IDS = CATEGORIES.map((c) => c.id);

export function isCategoryId(value: string): value is CategoryId {
  return CATEGORY_IDS.includes(value as CategoryId);
}
